const PUBLIC_URL = process.env.PUBLIC_URL || '';
const SERVICE_WORKER_URL = `${PUBLIC_URL}/service-worker.js`;

const isLocalPreviewHost = () => {
  if (typeof window === 'undefined') return false;
  const hostname = String(window.location.hostname || '').toLowerCase();
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.localhost')
  );
};

export const registerServiceWorker = () => {
  if (process.env.NODE_ENV !== 'production') return;
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  if (isLocalPreviewHost()) {
    window.addEventListener('load', async () => {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));
      } catch (error) {
        console.error('Service worker cleanup failed on localhost:', error);
      }
    });
    return;
  }

  let refreshing = false;

  const activateWaitingWorker = (registration) => {
    registration?.waiting?.postMessage({ type: 'SKIP_WAITING' });
  };

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register(SERVICE_WORKER_URL);

      if (registration.waiting) {
        activateWaitingWorker(registration);
      }

      registration.addEventListener('updatefound', () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.addEventListener('statechange', () => {
          if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
            activateWaitingWorker(registration);
          }
        });
      });

      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });
    } catch (error) {
      console.error('Service worker registration failed:', error);
    }
  });
};
